export const updateUrl = (history, url, path) => {
    const partes = url.split('?');
    const utmParams = partes[1];
    const nuevaCadena = utmParams ? path+'?'+utmParams : path;
    history.push(nuevaCadena);
};